import { useNavigate } from "react-router-dom";
import OnboardingHeader from "../../components/OnboardingComponents/OnboardingHeader";
import OnboardingCard from "../../components/OnboardingComponents/OnboardingCard";
import OnboardingButton from "../../components/OnboardingComponents/OnboardingButton";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F8F9FA]">
      <OnboardingHeader />

      <main className="w-full max-w-2xl mx-auto p-10 flex items-center justify-center min-h-[calc(100vh-80px)]">
        <OnboardingCard className="p-8 sm:p-12 w-full">
          <div className="flex flex-col items-center text-center">
            <h1 className="text-7xl sm:text-8xl font-bold text-[#1A1F3C] font-['Proxima_Nova']">
              404
            </h1>
            <h2 className="mt-4 text-2xl sm:text-3xl font-bold text-[#030724] font-['Proxima_Nova']">
              Page Not Found
            </h2>
            <p className="mt-3 text-lg font-normal text-[#46464D] font-['Proxima_Nova'] max-w-md">
              The page you are looking for doesn't exist or may have been moved.
              Let's get you back on track.
            </p>

            <div className="mt-10 w-full max-w-xs">
              <OnboardingButton
                title="Back to Inception Financial"
                onClick={() => navigate("/")}
              />
            </div>
          </div>
        </OnboardingCard>
      </main>
    </div>
  );
};

export default NotFound;
